import React from 'react'
import { components } from 'react-select'
import Tooltip from '@mui/material/Tooltip'
import PropTypes from 'prop-types'

const MultiValueContainerWithToolTip = props => {
  const { selectProps: { toolTipKey }, data } = props
  const toolTip = toolTipKey && data[toolTipKey]

  return (
    <Tooltip title={toolTip}>
      <div>
        <components.MultiValueContainer {...props} />
      </div>
    </Tooltip>
  )
}

MultiValueContainerWithToolTip.propTypes = {
  selectProps: PropTypes.shape({
    toolTipKey: PropTypes.string,
  }),
  data: PropTypes.any,
}

export default MultiValueContainerWithToolTip
